var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item real-open"},[_c('h3',[_c('i',{staticClass:"iconfont iconicon_jiantou"}),_vm._v("实时人流量数据")]),_c('div',{attrs:{"id":"realOpen"}})])
}]

export { render, staticRenderFns }